// Domain types for agentSettings resource

export enum WorkloadStatus {
    Good = 'good',
    Overloaded = 'overloaded',
    Underloaded = 'underloaded',
}

export enum OverloadedReason {
    TooManyRequests = 'too_many_requests',
    ComplexRequests = 'complex_requests',
    StaffingIssues = 'staffing_issues',
    IssuesOnSite = 'issues_on_site',
    Other = 'other',
}

export type AgentWorkload = {
    status: WorkloadStatus;
    overloadedReason: OverloadedReason | null;
    lastUpdatedAt: Date;
} | null;

export type AgencyCapacityFillingStatus = {
    nextMonthIsFilled: boolean;
    secondNextMonthIsFilled: boolean;
};

export type GetAgentWorkloadApiResponse = {
    workloadStatus: WorkloadStatus;
    overloadedReason: OverloadedReason | null;
    updatedAt: string;
};

export type GetAgencyCapacityFillingStatusApiResponse = {
    rate: number;
    complete: boolean;
    partial: boolean;
    empty: boolean;
};
